import {iFrameState} from "../../services/IFrameState";
import {PANEL_TYPE} from "../../../blink-sdk/Constants";
import {SUBSCRIBE_PLAN_STATE, subscribePlanController} from "./SubscribePlanController";
import {Router} from "../../../stem-core/src/ui/Router";
import {INLINE_GIFT_SUBSCRIPTION_URLS} from "../PanelConstants";
import {Dispatchable} from "../../../stem-core/src/base/Dispatcher";
import {apiSubscribe} from "../../../client/state/SubscriptionStore";
import {LoadingSpinner} from "../../ui/LoadingSpinner";
import {fetchSubscriptionPrices, subscribeFlowState} from "./SubscribeFlowState";
import {CARD_SECTION_STATE, paymentMethodController} from "../inline-donation/PaymentMethodController";
import {Messages} from "../../Messages";
import {PaymentMethodStore} from "../../../client/state/PaymentMethodStore";
import {addressController} from "./AddressController";
import {ADDRESS_SECTION_STATE} from "../pages/panels/address/AddressPanel";


class GiftSubscriptionFlowState extends Dispatchable {
    init() {
        console.assert(iFrameState.panelType === PANEL_TYPE.giftSubscription);

        this.giftBeneficiaryEmailAddress = "";
        this.name = "";
        this.message = "";

        subscribePlanController.update({
            subscribePlanState: SUBSCRIBE_PLAN_STATE.giftSubscription,
            selectedOffer: null,
            onSelectSuccess: async () => {
                // If we come from login page and switch to review, we want the back to take us to the plans
                // page. Currently, this is how we achieve that without disrupting the flow in any way.
                Router.localHistory.push(INLINE_GIFT_SUBSCRIPTION_URLS.subscriptionPlans);
                if (this.giftBeneficiaryEmailAddress) {
                    await this.onGiftDetailsProvided();
                    return;
                }
                Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.giftDetails);
            }
        });
    }

    async onGiftDetailsProvided() {
        paymentMethodController.update({
            cardSectionState: CARD_SECTION_STATE.chooseCard,
            initialPaymentMethod: paymentMethodController.getInitialPaymentMethod(),
            selectedPaymentMethod: paymentMethodController.getInitialPaymentMethod(),
            savePaymentMethod: true,
            getChooseCardButtonLabel: () => Messages.finalizePayment,
            getPayWithAddedCardButtonLabel: () => Messages.finalizePayment,
            getScope: () => PaymentMethodStore.Scope.RECURRING_PAYMENT,
            onSelectSuccess: () => giftSubscriptionFlowState.giftSubscription(),
        });
        if (!subscribePlanController.selectedOffer.shouldCollectAddress()) {
            LoadingSpinner.show();
            await fetchSubscriptionPrices();
            LoadingSpinner.hide();
            Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.reviewOrder);
            return;
        }
        addressController.update({
            addressSectionState: ADDRESS_SECTION_STATE.chooseAddress,
            onSelectSuccess: async () => {
                await fetchSubscriptionPrices();
                Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.reviewOrder);
            },
            onSelectCancel: () => Router.back(),
            continueLabel: Messages.reviewOrder,
        });
        Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.address);
    }

    async giftSubscription() {
        LoadingSpinner.show();
        const subscriptionDetails = await subscribeFlowState.getSubscribeEndpointPayload();
        Object.assign(subscriptionDetails.metadata, {
            gift: true,
            giftFrom: this.name,
            giftMessage: this.message,
        });

        let subscription = null;
        try {
            subscription = await apiSubscribe({
                ...subscriptionDetails,
                gift: true,
                giftBeneficiaryEmailAddress: this.giftBeneficiaryEmailAddress,
            });
        } catch (error) {
            if (error?.message) {
                paymentMethodController.update({paymentError: error});
                Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.fail);
            }
        } finally {
            LoadingSpinner.hide();
        }
        if (!subscription || !subscription.isActive()) {
            console.warn("Subscribe error: ", Messages.subscribeFailed);
            return;
        }
        Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.success);
    }

    clear() {
        paymentMethodController.clear();
        subscribePlanController.clear();
        addressController.update({
            addressSectionState: null,
            selectedAddress: null,
        });
        this.giftBeneficiaryEmailAddress = "";
        this.name = "";
        this.message = "";
    }
}

export const giftSubscriptionFlowState = new GiftSubscriptionFlowState();
